import _ from '@lodash';
import * as Actions from '../Actions/EmpresaPessoaFolgaActions';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null,
    template: null,
    id: null
};


const EmpresaPessoaFolgaReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAPESSOAFOLGAS:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAFOLGA_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    id: !_.isUndefined(action.id) ? action.id : null,
                };
            }
        case Actions.EMPRESAPESSOAFOLGA_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        case Actions.EMPRESAPESSOAFOLGA_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.GET_TEMPLATE:
            {
                return {
                    ...state,
                    template: action.payload,
                };
            }

        default:
            {
                return state;
            }
    }
};

const reducer = EmpresaPessoaFolgaReducer
export default reducer;
